import { useMemo } from "react";
import { ImagesVideosTabHeader } from "../controls/ImagesVideosTabHeader";
import { ScrollableMediaGallery } from "./ScrollableMediaGallery";
import { useTranslate } from "@refinedev/core";
import { useTemplateData } from "../../../../hooks/useTemplateData";
import { Flex } from "antd";
import { MediaKind } from "../../../../types";

export const DocumentImages = ({
  assetLibraryId,
  previewWidth,
  previewHeight,
  onReplaceSelectedAsset,
  customAddToCanvas,
  selectionMode,
}: {
  assetLibraryId: string;
  previewWidth: number;
  previewHeight: number;
  onReplaceSelectedAsset?: (
    assetId: string,
    path: string,
    mediaType: MediaKind
  ) => void;
  customAddToCanvas?: (assetId: string, path: string) => void;
  selectionMode?: boolean;
}) => {
  const {
    projectMediaAssetsData: { images, isLoading: isLoadingProjectMediaAssets },
  } = useTemplateData();
  const extractedImages = useMemo(() => {
    return images.filter((image) => image.source_type === "Extracted");
  }, [images]);

  const t = useTranslate();

  return (
    <Flex vertical style={{ height: "100%", overflow: "hidden" }}>
      <ImagesVideosTabHeader
        title={t("components.templates.settings.imagesVideosTab.fromDocument")}
        warning={t(
          "components.templates.settings.imagesVideosTab.badResolutionWarning"
        )}
      />
      <div
        id="infinite-scroll-document-images"
        style={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          marginTop: 16,
          marginBottom: 10,
        }}
      >
        <ScrollableMediaGallery
          scrollableTarget="infinite-scroll-document-images"
          currentAssetLibraryId={assetLibraryId}
          previewWidth={previewWidth}
          previewHeight={previewHeight}
          assetsFromBrandkitAndLibrary={extractedImages}
          isLoading={isLoadingProjectMediaAssets}
          onReplaceSelectedAsset={onReplaceSelectedAsset}
          customAddToCanvas={customAddToCanvas}
          selectionMode={selectionMode}
        />
      </div>
    </Flex>
  );
};
